import emptyTodo from "~/assets/images/dashboard/empty-todo.svg";

export const EmptyTodo = () => {
  return (
    <div className="mb-3 flex flex-col items-center justify-center p-6 text-center">
      {/* Icon */}
      <div>
        <img src={emptyTodo} alt="empty-todo" className="mb-4" />
      </div>

      {/* Title */}
      <h2 className="text-lg font-semibold text-gray-900">Stay on Track!</h2>

      {/* Description */}
      <p className="max-w-xl text-sm text-gray-600">
        You currently don&apos;t have any tasks assigned for your medical weight
        loss program.
      </p>
    </div>
  );
};

export const EmptyCompletedTodo = () => {
  return (
    <div className="mb-3 flex flex-col items-center justify-center p-6 text-center">
      {/* Icon */}
      <div>
        <img src={emptyTodo} alt="empty-todo" className="mb-4" />
      </div>

      {/* Title */}
      <h2 className="text-lg font-semibold text-gray-900">Stay on Track!</h2>

      {/* Description */}
      <p className="max-w-xl text-sm text-gray-600">
        You currently don&apos;t have any tasks completed for your medical weight
        loss program.
      </p>
    </div>
  );
};

